import { render } from "./Orders.vue?vue&type=template&id=7731ee1c&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=ts"
export * from "./Orders.vue?vue&type=script&lang=ts"

import "./Orders.vue?vue&type=style&index=0&id=7731ee1c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7731ee1c"

export default script